import { PaginationResponse, QueryManager } from '@/packages'
import { queryClient } from '../queryClient'
import { useFlatlistProps } from '@/utils'
import { CommunitySearchFeed } from '@/types'
import { api } from '@/app'

const BASE_URL = 'learn/search/'

export const communitySearchManager = new QueryManager({
  itemType: {} as CommunitySearchFeed,
  name: 'learn',
  queryClient: queryClient.client,

  listItems: async (limit, offset, filters) => {
    const url = BASE_URL

    const response = await api.get<PaginationResponse<CommunitySearchFeed>>(url, {
      params: {
        limit,
        offset,
        search: filters.search
      }
    })

    return response.data
  }
})

export function useLearnSearch(search: string, me = false) {
  const learnList = communitySearchManager.use({ filter: { search, me } })

  const listProps = useFlatlistProps(learnList)

  return { learnList, data: listProps?.data, listProps }
}
